<template>
    <v-row class="d-flex align-center header">
        <v-col cols="12" class="compagny">
          <v-row class="d-flex align-center">
            <v-col class="compagnyWidth d-flex align-center">
              <img class="compagnyLogo" src="/ressources/images/logo/LeReseauDynamique_logo_international_WHITE.svg" />
            </v-col>
          </v-row>
        </v-col>
        <v-col class="menuBG ">
          <v-row class="d-flex align-center MenuDesktop" >
            <v-col class="grid-pad">
              <v-row class=" ma-0 d-flex align-center" style=" position: relative; z-index: 10000; margin-right: auto !important; margin-left: auto !important;">
                  <div class="categories">
                    <h3 class="align-center"><router-link to="/" class=" d-flex align-center">Accueil</router-link> </h3>
                    <div class="subMenu">
                      <!--<router-link to="/#about"><h3 class="subText">À propos</h3></router-link>-->
                      <router-link to="/actualites"><h3 class="subText">Actualités</h3></router-link>
                    </div>
                  </div>
                  <div class="categories">
                    <h3 class="align-center"><router-link to="/inventaire?n=1" class=" d-flex align-center">Camions</router-link> </h3>
                    <div class="subMenu">
                      <router-link to="/inventaire?n=1"><h3 class="subText subTitle">Inventaire</h3></router-link>
                      <router-link to="/inventaire?n=1"><h3 class="subText">Neufs</h3></router-link>
                      <router-link to="/inventaire"><h3 class="subText">Usagés</h3></router-link>
                      <router-link to="/ventes"><h3 class="subText subTitle">Ventes</h3></router-link>
                      <router-link to="/obtenirPrix"><h3 class="subText subTitle">FAIRE ÉVALUER MON VÉHICULE</h3></router-link>
                      <a href="https://www.internationaltrucks.com/engines/s13integrated" target="_blank"><h3 class="subText subTitle">Moteur<br>S13 intégré</h3></a>
                      <router-link to="/camionElectrique"><h3 class="subText subTitle">Véhicules<br>Électriques</h3></router-link>
                      <router-link to="/location"><h3 class="subText subTitle">Location</h3></router-link>
                      <a href="https://www.internationaltrucks.com" target="_blank"><h3 class="subText subTitle">INTERNATIONAL</h3></a>
                      <a href="https://isuzudynamique.com/" target="_blank"><h3 class="subText subTitle">Isuzu</h3></a>
                      <a href="https://www.kalmarottawa.com/" target="_blank"><h3 class="subText subTitle">Kalmar Ottawa</h3></a>
                      <a href="https://battlemotors.com/" target="_blank"><h3 class="subText subTitle">Battle Motors</h3></a>
                      <a href="https://www.doepker.com/" target="_blank"><h3 class="subText subTitle">Remorque<br>Doepker</h3></a>
                    </div>
                  </div>
                  <div class="categories">
                    <h3 class="align-center"><router-link to="/piece" class=" d-flex align-center">pièces</router-link> </h3>
                    <div class="subMenu">
                        <router-link to="/promotion"><h3 class="subText subTitle">promotions</h3></router-link>
                        <a href="https://www.fleetrite.com/" target="_blank"><h3 class="subText">fleetrite<br><span class="subNote">(lien uniquement en anglais)</span></h3></a>
                        <a href="https://www.nexpart.com/fr/login-nexpart.html" target="_blank"><h3 class="subText">Nexpart<br><span class="subNote">(lien uniquement en anglais)</span></h3></a>
                        <a href="https://www.fleetcharge.com/ui/home" target="_blank"><h3 class="subText">fleet charge<br><span class="subNote">(lien uniquement en anglais)</span></h3></a>
                    </div>
                  </div>
                  <div class="categories">
                    <h3 class="align-center"><router-link to="/services" class=" d-flex align-center">Service</router-link> </h3>
                    <div class="subMenu">
                        <router-link to="/urgenceRoutiere"><h3 class="subText">Urgence routière</h3></router-link>
                        <a href="https://www.international.com/services/my-international" target="_blank"><h3 class="subText">MY INTERNATIONAL™<br><span class="subNote">(lien uniquement en anglais)</span></h3></a>
                    </div>
                  </div>
                  <div class="categories">
                    <h3 class="align-center"><router-link to="/nous-joindre" class=" d-flex align-center">Nos&nbsp;concessionnaires</router-link> </h3>
                  </div>
                  <div class="categories">
                    <h3 class="align-center"><router-link to="/carriere" class=" d-flex align-center">Carrières</router-link> </h3>
                    <div class="subMenu">
                        <router-link to="/carriere"><h3 class="subText">Ton avenir avec nous</h3></router-link>
                        <router-link to="/opportunites"><h3 class="subText">Opportunités d'emploi</h3></router-link>
                        <router-link to="/etudiant"><h3 class="subText">Stages et emplois étudiants</h3></router-link>
                    </div>
                  </div>
              </v-row>
            </v-col>
          </v-row>
          <v-row no-gutters class="MenuMobile grid-pad">
                <v-col class="d-flex align-center "><img class="" style="width:35px; height:35px" @click.stop="this.drawer = !this.drawer" src="/ressources/images/icon/menu.svg"/></v-col>
                <v-navigation-drawer class="drawer" v-model="drawer" left temporary>
                    <v-list>
                        <v-list-item class="pa-0 ma-0">
                            <v-expansion-panels>
                                <v-expansion-panel>
                                    <v-expansion-panel-title class="pl-5 pr-0">
                                        <v-row class="ma-0">
                                            <v-col cols="10" class="d-flex align-center justify-start"><router-link to="/" class=" d-flex align-center"><h3 class="align-center">Accueil </h3></router-link></v-col>
                                            <v-col cols="2" class="d-flex align-center justify-end"><div style="height:35px;"><img class="" style="width:100% ; height:100%;" src="/ressources/images/icon/expand_more_black_24dp.svg"/></div></v-col>
                                        </v-row>
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text><router-link to="/"><h3 class="subText">Accueil</h3></router-link></v-expansion-panel-text>
                                    <v-expansion-panel-text><router-link to="/actualites"><h3 class="subText">Actualités</h3></router-link></v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>                        
                        </v-list-item>
                        <v-list-item class="pa-0 ma-0">
                            <v-expansion-panels>
                                <v-expansion-panel style="padding: 0px;">
                                    <v-expansion-panel-title class="pl-5 pr-0">
                                        <v-row class="ma-0">
                                            <v-col cols="10" class="d-flex align-center justify-start"><h3 class="align-center"><router-link to="/" class=" d-flex align-center">Camions</router-link> </h3></v-col>
                                            <v-col cols="2" class="d-flex align-center justify-end"><div style="height:35px;"><img class="" style="width:100% ; height:100%;" src="/ressources/images/icon/expand_more_black_24dp.svg"/></div></v-col>
                                        </v-row>
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text style="padding: 0px;"><h3 class="subText subTitle">Inventaire</h3></v-expansion-panel-text>
                                    <v-expansion-panel-text><router-link to="/inventaire?n=1"><h3 class="subText">neufs</h3></router-link></v-expansion-panel-text>
                                    <v-expansion-panel-text><router-link to="/inventaire"><h3 class="subText">usagés</h3></router-link></v-expansion-panel-text> 
                                    <v-expansion-panel-text><router-link to="/ventes"><h3 class="subText">Ventes</h3></router-link></v-expansion-panel-text>
                                    <v-expansion-panel-text><router-link to="/obtenirPrix"><h3 class="subText">FAIRE ÉVALUER MON VÉHICULE</h3></router-link></v-expansion-panel-text>
                                    <v-expansion-panel-text><a href="https://www.internationaltrucks.com/engines/s13integrated" target="_blank"><h3 class="subText">Moteur<br>S13 intégré</h3></a></v-expansion-panel-text>
                                    <v-expansion-panel-text><router-link to="/camionElectrique"><h3 class="subText">Véhicules<br>Électriques</h3></router-link></v-expansion-panel-text>
                                    <v-expansion-panel-text><router-link to="/location"><h3 class="subText">Location</h3></router-link></v-expansion-panel-text>
                                    <v-expansion-panel-text><a href="https://www.internationaltrucks.com" target="_blank"><h3 class="subText">INTERNATIONAL</h3></a></v-expansion-panel-text>
                                    <v-expansion-panel-text><a href="https://isuzudynamique.com/" target="_blank"><h3 class="subText">Isuzu</h3></a></v-expansion-panel-text>
                                    <v-expansion-panel-text><a href="https://www.kalmarottawa.com/" target="_blank"><h3 class="subText">Kalmar Ottawa</h3></a></v-expansion-panel-text>
                                    <v-expansion-panel-text><a href="https://battlemotors.com/" target="_blank"><h3 class="subText">Battle Motors</h3></a></v-expansion-panel-text>
                                    <v-expansion-panel-text><a href="https://www.doepker.com/" target="_blank"><h3 class="subText">Remorque<br>Doepker</h3></a></v-expansion-panel-text>
                                    <!---->    
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-list-item>
                        <v-list-item class="pa-0 ma-0">
                            <v-expansion-panels>
                                <v-expansion-panel>
                                    <v-expansion-panel-title class="pl-5 pr-0">
                                        <v-row class="ma-0">
                                            <v-col cols="10" class="d-flex align-center justify-start"><h3 class="align-center"><router-link to="/" class=" d-flex align-center">pièces</router-link> </h3></v-col>
                                            <v-col cols="2" class="d-flex align-center justify-end"><div style="height:35px;"><img class="" style="width:100% ; height:100%;" src="/ressources/images/icon/expand_more_black_24dp.svg"/></div></v-col>
                                        </v-row>
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text><router-link to="/promotion"> <h3 class="subText subTitle">promotions</h3></router-link></v-expansion-panel-text>
                                    <v-expansion-panel-text><a href="https://www.fleetrite.com/" target="_blank"><h3 class="subText">fleetrite<br><span class="subNote">(lien uniquement en anglais)</span></h3></a></v-expansion-panel-text>
                                    <v-expansion-panel-text><a href="https://www.nexpart.com/fr/login-nexpart.html" target="_blank"><h3 class="subText">nexpart<br><span class="subNote">(lien uniquement en anglais)</span></h3></a></v-expansion-panel-text>
                                    <v-expansion-panel-text><a href="https://www.fleetcharge.com/ui/home" target="_blank"><h3 class="subText">fleetcharge<br><span class="subNote">(lien uniquement en anglais)</span></h3></a></v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>                        
                        </v-list-item>
                        <v-list-item class="pa-0 ma-0">
                            <v-expansion-panels>
                                <v-expansion-panel>
                                    <v-expansion-panel-title class="pl-5 pr-0">
                                        <v-row class="ma-0">
                                            <v-col cols="10" class="d-flex align-center justify-start"><h3 class="align-center"><router-link to="/" class=" d-flex align-center">Services</router-link> </h3></v-col>
                                            <v-col cols="2" class="d-flex align-center justify-end"><div style="height:35px;"><img class="" style="width:100% ; height:100%;" src="/ressources/images/icon/expand_more_black_24dp.svg"/></div></v-col>
                                        </v-row>
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text><router-link to="/urgenceRoutiere"><h3 class="subText">Urgence routière</h3></router-link></v-expansion-panel-text>
                                    <v-expansion-panel-text><a href="https://www.international.com/services/my-international" target="_blank"><h3 class="subText">MY INTERNATIONAL™<br><span class="subNote">(lien uniquement en anglais)</span></h3></a></v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>                        
                        </v-list-item>
                        <v-list-item class="pa-0 ma-0"><h3 class="title align-center"><router-link to="/nous-joindre" class=" d-flex align-center">Nos concessionnaires</router-link> </h3></v-list-item>
                        <v-list-item class="pa-0 ma-0">
                            <v-expansion-panels>
                                <v-expansion-panel>
                                    <v-expansion-panel-title class="pl-5 pr-0">
                                        <v-row class="ma-0">
                                            <v-col cols="10" class="d-flex align-center justify-start"><h3 class="align-center"><router-link to="/" class=" d-flex align-center">Carrières</router-link> </h3></v-col>
                                            <v-col cols="2" class="d-flex align-center justify-end"><div style="height:35px;"><img class="" style="width:100% ; height:100%;" src="/ressources/images/icon/expand_more_black_24dp.svg"/></div></v-col>
                                        </v-row>
                                    </v-expansion-panel-title>
                                    <v-expansion-panel-text><router-link to="/carriere"><h3 class="subText">Ton avenir avec nous</h3></router-link></v-expansion-panel-text>
                                    <v-expansion-panel-text><router-link to="/opportunites"><h3 class="subText">Opportunités d’emploi</h3></router-link></v-expansion-panel-text>
                                    <v-expansion-panel-text><router-link to="/etudiant"><h3 class="subText">Stages et emplois étudiants</h3></router-link></v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>                        
                        </v-list-item>
                    </v-list>
                </v-navigation-drawer>         
            </v-row>
        </v-col>
    </v-row>
  </template>
  <style>
    .v-navigation-drawer__scrim {
      pointer-events: none !important;
      opacity: 0 !important;
    }
  </style>
  <style scoped>
    .v-expansion-panel-text {padding: 0px !important;}
  </style>
  <style scoped>
    /*#region emergency*/
      .emergencyWidth {min-width: 700px; max-width: 700px; padding: 0px;} /*Padding 0 is correcting vuetify*/
      .emergencyBox {border: 2px solid rgb(var(--black)); border-radius: 5px; margin: 10px 0px !important;}
      .phoneBG { background-color: rgb(var(--black)); padding: 0px; position: relative;}
      .emergencyTextPosition{ padding: 0px 20px !important; text-align: right;}
    /*#endregion */
    /*#region compagny*/
      .compagny {height: 100px; background-color: rgb(var(--black)); max-height: 100px; padding: 0px;}
      .compagnyWidth {min-width: 25%; max-width: 25%; padding: 0px;}
      .compagnyLogo { width: auto; padding: 15px 10px; max-height: 85px; }
      .compagnyText {max-height: 99px; font-family: TxtOffBDI; text-align: justify; overflow: hidden; color: #2499FF; margin-top: -10px; }
    /*#endregion */
    /*#region Menu*/
      .menuBG { background-color: rgb(var(--gray));}
      .MenuDesktop{display: block;}
      .MenuMobile {display: none;}
      .MenuMobile h3 { text-transform: uppercase; }
      .menu h3 {font-family: TxtOffBDI; color: rgb(var(--white)); text-transform: uppercase; text-align: center; height: 100%;}
      .menu { height: auto; }
      .menu:hover {background-color: rgb(var(--primary)); }
      .categories a{font-family: TxtOffBDI; font-size: 16px; color: rgb(var(--white)); text-transform: uppercase; text-align: center; position: relative; height:50px !important; padding: 10px 20px; text-transform: uppercase; font-weight: 700; }
      .categories:hover a{background-color:rgb(var(--secondary));} 
      .categories .subMenu a{ height: unset; padding: 0px; text-align: left; background-color: rgb(var(--ligthGray)); color: rgb(var(--gray));}
      .categories .subMenu a:hover{color: rgb(var(--secondary));} 
      .subMenu { font-family: TxtOffBDI; display: none; position:absolute; background-color: rgb(var(--ligthGray)); min-width: 300px; }
      .subText { padding: 10px 20px; text-transform: uppercase;}
      .subNote { display: block; font-size: 10px; font-weight: 400; text-transform: none; opacity: 0.8; }
      .subTitle{ color: rgb(var(--white)); background-color: rgb(var(--gray));}
      .blueSubTitle { color: rgb(var(--white)); background-color: rgb(var(--secondary)); }
      .MenuMobile .title {margin: 10px; padding: 10px;}
      .v-expansion-panel-text__wrapper {padding: 0px !important;}
      .categories:hover .subMenu { display: block; }

      .zoomHover { height: inherit; max-height: 100%; width: auto;  overflow: hidden;  }
      .zoomHover img { transition: transform .5s ease; }
      .zoomHover:hover img { transform: scale(1.1); }
      .logoWidth { display: block; min-width: 350px; max-width: 350px; }
      .bg360 { height: 120%; width: 115px; background-color: rgb(var(--ligthGray)); position: relative; top: -10%; right:0%; transform: skewX(-10deg);  z-index: 10; }
      .bgS13 { height: 140%; width: 125px;background-color: rgb(var(--primary)); position: absolute; top: -20%; right:-6%; transform: skewX(-10deg); z-index: 100; }
      .bgE { height: 120%; width: 115px; background-color: rgb(var(--secondary)); position: absolute; top: -10%; right:0%; transform: skewX(0deg);  z-index: 10; } 
      .logo360 { position: absolute; height: auto; width: 100%; max-width: 110px; top: 30%; margin-left: auto; margin-right: auto; display: block; }
      .logoS13 { height: 100%; width: auto; max-width: 115px; margin-left: auto; margin-right: auto; display: block; }
      .logoE { height: 150%; width: auto;  max-width: 110px;  margin-left: auto; margin-right: auto; display: block; margin-top: -15px; }
    /*#endregion */

    @media handheld, only screen and (max-width: 600px) {
      
    }
    @media handheld, only screen and (max-width: 960px) {
      .MenuDesktop{display: none !important;}
      .MenuMobile { display: block !important; position: relative; z-index: 9999; }
      .drawer { z-index: 10000; }
      .compagnyText {display: none; }
      .compagnyWidth {min-width: 50%; max-width: 75%; }
      .compagnyLogo { width: auto; padding: 15px 10px; max-height:60px;}
    }
    @media handheld, only screen and (max-width: 1065px) { 
      .logoWidth {display: none;} 
    }
    @media handheld, only screen and (max-width: 1279px) {
      .categories a {font-size: 10px !important;}
    }
    @media handheld, only screen and (max-width: 1500px) {
      .categories a {font-size: 12px;}
      .logoWidth {  min-width: 250px; max-width: 250px; }
      .bg360 { width: 85px; }
      .bgS13 { width: 95px; }
      .bgE { width: 85px !important; } 
      .logo360 { height: auto; width: 90%; }
      .logoS13 { height: auto; width: 100%; margin-top:12%; }
    }
    
  </style>
  <script>
  
  export default {
    name: 'header',
    data:()=>({
      drawer: false,
      menu:[
            {title:'Accueil',path:'/'},
            {title:'Inventaire',path:'/'},
            {
              title:'Configurez<br>votre&nbsp;véhicule',
              subMenu: [
                {subTitle:'modèles'},
                {subTitle:'Série LT',path:'/'},
                {subTitle:'Série RH',path:'/'},
                {subTitle:'Série HX',path:'/'},
                {subTitle:'Série HV',path:'/'},
                {subTitle:'Série MV',path:'/'},
                {subTitle:'Série eMV',path:'/'},
                {subTitle:'Série CV',path:'/'}
              ]
            },
            {title:'pièces',path:'/'},
            {title:'Services',path:'/'},
            {title:'Nos&nbsp;concessionnaires',path:'/'},
            {title:'Carrières',path:'/'}
        ]
    }),
    mounted() {

    },
    methods:{

    },
    components: { }
  }
  </script>